import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-bg">
      <div className="text-center">
        <p className="text-6xl font-bold text-sage mb-4">404</p>
        <h1 className="text-xl font-semibold text-ink-dark mb-2">
          {t('common.not_found.titolo')}
        </h1>
        <p className="text-ink-soft text-sm mb-6">
          {t('common.not_found.testo')}
        </p>
        <Link
          to="/dashboard"
          className="text-sage hover:underline text-sm font-medium"
        >
          {t('common.not_found.torna_dashboard')}
        </Link>
      </div>
    </div>
  );
}
